import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'
import { Box, Button } from '@mui/material'
import Typography from '@/ui/components/typography'

export const ExpiredScreenWrapper = styled(Box)`
    position: fixed;
    inset: 0;
    z-index: 999;
    background-color: var(--color-dark);
    background-image: linear-gradient(
        180deg,
        var(--color-gradient-top) 0%,
        var(--color-gradient-bottom) 800px
    );
    overflow: hidden;
`

export const MenuContainer = styled(Box)`
    position: absolute;
    top: 16px;
    right: var(--container-padding-inline, 2rem);
    z-index: 1;
`

export const BodyText = styled(Typography)<{ theme?: TTheme }>`
    color: ${({ theme }) => theme?.colors?.greys?.[700]};
`

export const ContactSupportButton = styled(Button)<{ theme?: TTheme }>`
    height: 32px;
    width: 150px;
    border-radius: 40px;
    padding: 6px 32px;
    text-transform: none;
    margin-top: 2rem;
    white-space: nowrap;
    font: ${({ theme }) => theme.fonts.pri14R};
    background: ${({ theme }) => theme?.colors?.primary?.[950]};
    color: ${({ theme }) => theme?.colors?.greys?.[0]};
    &:hover {
        background: ${({ theme }) => theme?.colors?.primary?.[950]};     
        opacity: 0.85;
    }
`
